// Libs
import React from 'react';
import { Typography, Box } from '@mui/material';

const ProductInfoFields = ({
  product,
  piRequiredText,
  isUnavailableForOrder,
  unavailableLabel,
  classes,
  cx,
}) => {
  const {
    product_id: stockNumber,
    brand_category: brandCategory,
    unit_measure: unitMeasure,
    prepack_quantity: perUnitQty,
    order_limit: maxAllowedQty,
    product_available_qty: inStock,
    owner,
  } = product || {};

  return (
    <>
      <Typography
        variant="h3"
        my={2}
        className={cx(classes.blockHeader, classes.stockNumber)}>
        Stock Number: {stockNumber}
      </Typography>
      <Box display="flex">
        <Typography className={classes.productInfoHeader}>
          Therapeutic Area:&nbsp;
        </Typography>
        <Typography className={classes.productInfoText}>
          {perUnitQty ? owner : 'N/A'}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography className={classes.productInfoHeader}>
          Brand Category:&nbsp;
        </Typography>
        <Typography className={classes.productInfoText}>
          {perUnitQty ? brandCategory : 'N/A'}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography className={classes.productInfoHeader}>
          Unit Measure:&nbsp;
        </Typography>
        <Typography className={classes.productInfoText}>
          {perUnitQty ? unitMeasure : 'N/A'}
        </Typography>
      </Box>
      <Box display="flex" mb={1}>
        <Typography className={classes.productInfoHeader}>
          PI Required:&nbsp;
        </Typography>
        <Typography className={classes.productInfoText}>
          {piRequiredText}
        </Typography>
      </Box>
      <Box display="flex">
        <Typography className={classes.productInfoHeader}>
          Per Unit Qty:&nbsp;
        </Typography>
        <Typography className={classes.productInfoText}>
          {perUnitQty ? perUnitQty : 'N/A'}
        </Typography>
      </Box>
      {maxAllowedQty !== null && (
        <Box display="flex">
          <Typography className={classes.productInfoHeader}>
            Max Allowed Qty:&nbsp;
          </Typography>
          <Typography className={classes.productInfoText}>
            {maxAllowedQty}
          </Typography>
        </Box>
      )}
      <Box display="flex">
        {!isUnavailableForOrder ? (
          <Typography className={classes.qtyInfoText}>
            In Stock: {inStock}
          </Typography>
        ) : (
          <Typography className={classes.outOfStockText}>
            {unavailableLabel}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default ProductInfoFields;
